module.exports = __webpack_public_path__ + "img/identity.00aa6526.png";